export default __webpack_public_path__ + "src/static/img/jpg/mujer-sonriente-compras-linea-laptop-tarjeta-credito.jpg";